import { useState, useEffect, useMemo } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

/* contexts */
import { Context } from '../../../context/UserContext';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Stack, Button, Box, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit, Print } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';
import CustomDialog from '../../layout/CustomDialog';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import * as EquipeAPI from '../../../api/equipe';
import * as PlantaoAPI from '../../../api/plantao';
import * as TabelaAPI from '../../../api/tabela';
import * as DataListAPI from '../../../api/dataList';

import { obterColaboradorByPessoaId, obterCargoByEmpresaId, obterNivelByEmpresaId } from '../../../api/rh';

import DataList from '../../form/DataList';
import Input from '../../form/Input';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';
import Select from '../../form/Select';

import { useMRTState } from '../../../hooks/useMRTState';

function Form({
    dados,
    setDados,
    empresaId,
    empresaIds,
    handleSubmit,

    btnText,
    caminhoVoltar,
    optionsEmpresa,
    parametro,
    EquipeIntegrantes,
    setEquipeIntegrantes,
}) {
    const [pessoa, setPessoa] = useState({});

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const [novoColaborador, setNovoColaborador] = useState({
        uuid: null,
        equipeId: dados.id,
        pessoaId: null,
        cargoId: null,
        nivelId: null,
        horarioDiferenciado: false,
        custoFixo: false,
        outroDia: false,
        inicio: null,
        termino: null,
        funcao: 'Adicionar',
        Pessoa: { CPForCNPJ: null, descricao: null },
        ativo: true,
    });

    // Estado para rastrear a aba ativa
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState('integrantes');

    //abas
    const [tabEnabled, setTabEnabled] = useState({
        cabeçalho: true,
        integrantes: true,
    });
    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva('cabecalho');
                break;
            case 1:
                setGridAtiva('integrantes');
                break;
            default:
                setGridAtiva('cabecalho');
        }
    };

    const mrt = useMRTState({
        storageKey: 'equipe.index',
        initialState: {
            columnFilterFns: {},
            columnFilters: [],
            globalFilter: '',
            sorting: [],
            pagination: {
                pageIndex: 0,
                pageSize: parametro?.paginacao || 10,
            },
        },
    });

    const {
        columnFilterFns,
        setColumnFiltersMode,
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
        isLoading,
        setIsLoading,
        isError,
        setIsError,
        isRefetching,
        setIsRefetching,
        rowCount,
        setRowCount,
    } = mrt;

    //set datalist
    const [OptionsColaborador, setOptionsColaborador] = useState([]);

    //Select
    const [optionsCargo, setOptionsCargo] = useState([]);
    const [optionsNivel, setOptionsNivel] = useState([]);
    const [OptionsTipo, setOptionsTipo] = useState([]);

    //Atualiza o Datalist
    const consultaDatalistColaborador = async (empresaId, filtro, ativo, tipo) => {
        const result = await DataListAPI.dataListColaborador({ empresaId, filtro, ativo, tipo });
        return result;
    };

    //Consultas
    const consultaTipo = async (empresaIds) => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);
        setOptionsTipo(result || []);
    };
    const consultaCargo = async (empresaId) => {
        if (!empresaId) {
            return;
        }
        try {
            const data = await obterCargoByEmpresaId({ empresaId });
            setOptionsCargo(data || []);
        } catch (error) {
            console.error(error);
            throw new Error('Erro ao buscar cargo'); // Lançar um erro amigável
        }
    };
    const consultaNivel = async (empresaId) => {
        if (!empresaId) {
            return;
        }
        try {
            const data = await obterNivelByEmpresaId({ empresaId });
            setOptionsNivel(data || []);
        } catch (error) {
            console.error(error);
            throw new Error('Erro ao buscar nível');
        }
    };

    useEffect(() => {
        setRowCount(dados?.EquipeIntegrantes?.length || 0);
        consultaTipo(empresaIds);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //gridAtiva
    useEffect(() => {
        if (gridAtiva) {
            fetchData(gridAtiva);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, gridAtiva]);

    useEffect(() => {
        //atualizar a tabela pessoa com as tabels filhas
        setDados((prev) => {
            return {
                ...prev,
                EquipeIntegrantes: EquipeIntegrantes,
            };
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [EquipeIntegrantes]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await obterColaboradorByPessoaId({ pessoaId: novoColaborador.pessoaId });
                if (!data) {
                    return;
                }
                setNovoColaborador((prev) => ({
                    ...prev,
                    Pessoa: data?.Pessoa,
                    cargoId: data?.cargoId,
                    nivelId: data?.nivelId,
                    equipeId: dados.id,
                }));
            } catch (error) {
                console.error('Erro ao buscar colaborador:', error);
            }
        };

        novoColaborador.pessoaId && fetchData();
    }, [novoColaborador.pessoaId]);

    useEffect(() => {
        if (dados.empresaId) {
            consultaCargo(dados.empresaId);
            consultaNivel(dados.empresaId);
        }
    }, [dados.empresaId]);

    //funções para o colaborador
    const fetchData = async (grid) => {
        // Função auxiliar para aplicar filtros e ordenação
        const applyLocalFiltersAndSorting = (data) => {
            // Aplica os filtros e ordenações locais
            let result = data;

            // Exemplo de aplicação de filtro global
            if (globalFilter) {
                result = result.filter((item) => item.name.includes(globalFilter));
            }

            // Aplicar ordenação, filtro de colunas, etc., conforme necessário
            // result.sort(...), result.filter(...), etc.

            return result;
        };

        if (!EquipeIntegrantes.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        let filteredData = [];

        if (dados.id) {
            if (grid === 'integrantes') {
                try {
                    EquipeAPI.listarIntegrantes({
                        start: pagination.pageIndex * pagination.pageSize,
                        size: pagination.pageSize,
                        filters: JSON.stringify(columnFilters ?? []),
                        filtersMode: JSON.stringify(columnFilterFns ?? []),
                        globalFilter: globalFilter ?? '',
                        sorting: JSON.stringify(sorting ?? []),
                        equipeId: dados.id,
                    }).then((response) => {
                        setEquipeIntegrantes(response.data);
                        setRowCount(response.meta.totalRowCount);
                    });
                } catch (error) {
                    setIsError(true);
                    console.error(error);
                    return;
                }
            }
        } else {
            if (grid === 'integrantes') {
                filteredData = applyLocalFiltersAndSorting(EquipeIntegrantes);
                setEquipeIntegrantes(filteredData);
            }
            filteredData = applyLocalFiltersAndSorting(EquipeIntegrantes);
        }

        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };
    const handleColaborador = async () => {
        if (dados.id) {
            const result = await EquipeAPI.integrantes(novoColaborador);
            if (result.status === 202) {
                setNovoColaborador({
                    ...novoColaborador,
                    uuid: result.data.uuid,
                    equipeId: dados.id,
                    funcao: 'Editar',
                });
                setFlashMessage('Integrante já consta na EQUIPE?', 'error');
                return;
            }
            setFlashMessage(result.data.message, result.data.type);
            if (result.data.type === 'success') {
                setEquipeIntegrantes(result.data.integrantes);
            }
        } else {
            if (novoColaborador.funcao.toLowerCase() === 'editar') {
                EquipeIntegrantes[novoColaborador.index] = {
                    ...EquipeIntegrantes[novoColaborador.index],
                    ...novoColaborador,
                };
            } else if (novoColaborador.funcao.toLowerCase() === 'deletar') {
                EquipeIntegrantes.splice(novoColaborador.index, 1);
            } else {
                try {
                    setEquipeIntegrantes((prevEquipeIntegrantes) => [...prevEquipeIntegrantes, novoColaborador]);
                } catch (error) {
                    console.error('Erro ao adicionar novo colaborador:', error);
                }
            }
        }
        limparNovoColaborador();
    };
    const handleEditarOrDeletar = async (originalRow, row, funcao) => {
        // Define os dados para o novo produto
        const newData = {
            uuid: originalRow.uuid,
            Pessoa: originalRow.Pessoa,

            equipeId: originalRow.equipeId,
            pessoaId: originalRow.pessoaId,
            cargoId: originalRow.cargoId,
            nivelId: originalRow.nivelId,

            horarioDiferenciado: originalRow.horarioDiferenciado,
            custoFixo: originalRow.custoFixo,
            outroDia: originalRow.outroDia,
            inicio: originalRow.inicio,
            termino: originalRow.termino,

            ativo: originalRow.ativo,
            funcao: funcao,
            index: row,
        };

        // Atualize o estado do novo objeto
        setPessoa(originalRow.Pessoa);
        setNovoColaborador(newData);

        return;
    };
    const limparNovoColaborador = () => {
        setNovoColaborador({
            uuid: null,
            equipeId: dados.id,
            pessoaId: null,
            cargoId: null,
            nivelId: null,
            funcao: 'Adicionar',
            Pessoa: { CPForCNPJ: null, descricao: null },
            horarioDiferenciado: false,
            outroDia: false,
            custoFixo: false,
            inicio: null,
            termino: null,
            ativo: true,
        });
        setPessoa({});
    };

    async function handleChange(e) {
        const { name, value, checked, type, options, selectedIndex } = e.target;

        if (name.startsWith('Pessoa.')) {
            setPessoa({
                ...pessoa,
                [name.split('.')[1]]: value,
            });

            const result = await consultaDatalistColaborador(dados.empresaId, value, true, null);
            setOptionsColaborador(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id || null;
            setNovoColaborador((prevState) => ({
                ...prevState,
                pessoaId: selectedId,
            }));
        } else if (name.startsWith('novoColaborador.')) {
            const campo = name.split('.')[1];

            setNovoColaborador({
                ...novoColaborador,
                [campo]: type === 'checkbox' ? checked : type === 'select-one' ? options[selectedIndex].text : value,
            });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }
    async function handleOnBlur(e) {
        if (e.target.name === 'descricao' && btnText === 'Cadastrar') {
            //verifica duplicidade
            const duplicidade = await TabelaAPI.duplicidadeDescricao(
                document.getElementById('empresaId').value,
                'Equipe',
                e.target.value
            );

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Equipes/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        handleSubmit(dados);
    };

    const columns = useMemo(
        () => [
            {
                id: 'integrantes',
                header: `Integrantes da equipe de plantão`,
                columns: [
                    {
                        accessorKey: 'Pessoa.CPForCNPJ',
                        header: 'CPF',
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info('Célula clicada:', cell.getValue(), row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'Pessoa.descricao',
                        header: 'Colaborador',
                        Cell: ({ row }) => {
                            return row.original.Pessoa.descricao ?? '';
                        },
                    },
                    {
                        id: 'rhCargo.descricao',
                        header: 'Cargo',
                        accessorFn: (row) => row?.rhCargo?.descricao ?? '',
                    },
                    {
                        id: 'rhNivel.descricao',
                        header: 'Nível',
                        accessorFn: (row) => row?.rhNivel?.descricao ?? '',
                    },
                    {
                        accessorKey: 'horarioDiferenciado',
                        header: 'Horário Diferenciado',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: 1 },
                            { label: 'Não', value: 0 },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.horarioDiferenciado ? 'Sim' : 'Não';
                        },
                    },
                    {
                        accessorFn: (row) => new Date(row),
                        accessorKey: 'inicio',
                        header: 'Início',
                        muiFilterTextFieldProps: {
                            sx: {
                                minWidth: '80px',
                            },
                        },

                        filterVariant: 'time',
                        sortingFn: 'time',

                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'date',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ row }) => (
                            <span>{row.original?.inicio ? moment(row.original.inicio, 'HH:mm').format('HH:mm') : ''}</span>
                        ),
                    },
                    {
                        accessorFn: (row) => new Date(row),
                        accessorKey: 'termino',
                        header: 'Término',
                        muiFilterTextFieldProps: {
                            sx: {
                                minWidth: '80px',
                            },
                        },

                        filterVariant: 'time',
                        sortingFn: 'time',

                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'date',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: {
                                minWidth: '200px',
                            },
                        },
                        Cell: ({ renderedCellValue, row }) => {
                            return (
                                <span>{row.original?.termino ? moment(row.original.termino, 'HH:mm').format('HH:mm') : ''}</span>
                            );
                        },
                    },
                    {
                        accessorKey: 'custoFixo',
                        header: 'Custo Fixo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: 1 },
                            { label: 'Não', value: 0 },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.custoFixo ? 'Sim' : 'Não';
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: 1 },
                            { label: 'Não', value: 0 },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.ativo ? 'Sim' : 'Não';
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [EquipeIntegrantes]
    );
    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <h1>Equipe</h1>
                    <TabList>
                        <Tab disabled={!tabEnabled.cabeçalho} title={'Cabeçalho da equipe'}>
                            Cabeçalho
                        </Tab>
                        <Tab disabled={!tabEnabled.integrantes} title={'Integrantes da equipe'}>
                            Integrantes
                        </Tab>
                    </TabList>
                    <TabPanel>
                        <div>
                            <SelectEmpresa
                                text="Selecione a Empresa"
                                name="empresaId"
                                options={optionsEmpresa}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.empresaId || ''}
                                required
                                notOptNull={true}
                            />
                            <Input
                                text="Descrição"
                                type="text"
                                name="descricao"
                                placeholder="Equipe"
                                title="Digite o nome da equipe"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.descricao || ''}
                                required={true}
                            />
                            <Select
                                name="plantaoTipoId"
                                title="Selecione o tipo"
                                text="Tipo"
                                inputWidth="150px"
                                options={OptionsTipo}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.plantaoTipoId ?? ''}
                                notOptNull={false}
                                required={true}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={!!dados.ativo}
                            />
                        </div>
                        <div>
                            <Input
                                text="Início"
                                type="time"
                                name="inicio"
                                placeholder=""
                                title="Hora de início do Plantão"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.inicio ?? ''} //moment(dados.inicio).format("HH:mm")}
                            />
                            <Input
                                text="Término"
                                type="time"
                                name="termino"
                                placeholder=""
                                title="Hora de término do Plantão"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.termino ?? ''}
                            />
                            <Checkbox
                                title="Informa que o plantão terminará no dia seguinte"
                                text="Outro dia"
                                name="outroDia"
                                handleOnChange={handleChange}
                                value={dados.outroDia}
                                checked={!!dados.outroDia}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div
                            style={{
                                margin: '1em',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1em' }}>
                                <DataList
                                    text="Colaborador"
                                    name="Pessoa.descricao"
                                    inputWidth="300px"
                                    filteredOptions={OptionsColaborador}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoa.descricao || ''}
                                />
                                <Select
                                    name="novoColaborador.cargoId"
                                    text="Cargo"
                                    options={optionsCargo}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoColaborador.cargoId ?? ''}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Select
                                    name="novoColaborador.nivelId"
                                    text="Nível"
                                    options={optionsNivel}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={novoColaborador.nivelId ?? ''}
                                    isEnum={false}
                                    notOptNull={false}
                                />
                                <Checkbox
                                    title="Horário diferenciado do colaborador dentro do plantão"
                                    text="Horário diferenciado"
                                    name="novoColaborador.horarioDiferenciado"
                                    handleOnChange={handleChange}
                                    value={novoColaborador.horarioDiferenciado}
                                    checked={!!novoColaborador.horarioDiferenciado}
                                />
                                {novoColaborador.horarioDiferenciado && (
                                    <>
                                        <Input
                                            text="Início"
                                            type="time"
                                            name="novoColaborador.inicio"
                                            placeholder=""
                                            title="Início do Plantão"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={novoColaborador.inicio ?? ''}
                                        />
                                        <Input
                                            text="Término"
                                            type="time"
                                            name="novoColaborador.termino"
                                            placeholder=""
                                            title="Término do Plantão"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={novoColaborador.termino ?? ''}
                                        />
                                        <Checkbox
                                            title="Indica que o plantão desse colaborador terminará no dia seguinte"
                                            text="Outro dia"
                                            name="novoColaborador.outroDia"
                                            handleOnChange={handleChange}
                                            value={novoColaborador.outroDia}
                                            checked={!!novoColaborador.outroDia}
                                        />
                                        <Checkbox
                                            title="Indica que esse colaborador terá também um cálculo do custo operacional diferenciado, o mesmo será aplicado ao cálculo do custo fixo na empresa ou tabulado as horas dentro de cada plantão para efeito de custos operacionais"
                                            text="Custo fixo"
                                            name="novoColaborador.custoFixo"
                                            handleOnChange={handleChange}
                                            value={novoColaborador.custoFixo}
                                            checked={!!novoColaborador.custoFixo}
                                        />
                                    </>
                                )}
                                <Checkbox
                                    title="Ativa"
                                    text="Ativo"
                                    name="novoColaborador.ativo"
                                    handleOnChange={handleChange}
                                    value={novoColaborador.ativo}
                                    checked={!!novoColaborador.ativo}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparNovoColaborador();
                                    }}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoColaborador?.funcao?.toLowerCase() === 'deletar' ? 'error' : 'info'}
                                    onClick={() => handleColaborador(novoColaborador)}
                                    disabled={!novoColaborador.pessoaId ? true : false}
                                    style={{ marginLeft: '5px' }}
                                >
                                    {novoColaborador.funcao}
                                </Button>
                            </div>
                            <ThemeProvider theme={theme}>
                                <MaterialReactTable
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            muiTableHeadCellProps: {
                                                align: 'center',
                                            },
                                            size: 100,
                                        },
                                        'mrt-row-numbers': {
                                            enableColumnOrdering: true, //turn on some features that are usually off
                                            enableResizing: true,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontSize: '1.2rem',
                                                },
                                            },
                                        },
                                        'mrt-row-select': {
                                            enableColumnActions: true,
                                            enableHiding: true,
                                            size: 50,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    enableGlobalFilterModes
                                    //enableColumnResizing
                                    enableColumnOrdering
                                    enableEditing
                                    renderRowActions={({ row, table }) => (
                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                            <Tooltip arrow placement="top" title="Editar">
                                                <span>
                                                    {' '}
                                                    <IconButton
                                                        onClick={() => {
                                                            handleEditarOrDeletar(row.original, row.index, 'Editar');
                                                        }}
                                                        disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip arrow placement="right" title="Cancelar">
                                                <span>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleEditarOrDeletar(row.original, row.id, 'Deletar')}
                                                        disabled={localStorage.getItem('cancelar') === 'true' ? false : true}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    )}
                                    renderTopToolbarCustomActions={() => (
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '8px',
                                            }}
                                        >
                                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                                <div>
                                                    {' '}
                                                    <Button
                                                        color="secondary"
                                                        onClick={() => navigate('/TabelaPrecos/CreateOrEdit')}
                                                        variant="contained"
                                                        disabled={
                                                            true
                                                            // localStorage.getItem("incluir") ===
                                                            // "true"
                                                            //     ? false
                                                            //     : true
                                                        }
                                                    >
                                                        Novo
                                                    </Button>
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )}
                                    columns={columns}
                                    data={EquipeIntegrantes}
                                    enableRowSelection
                                    getRowId={(row) => row.uuid}
                                    manualFiltering
                                    manualPagination
                                    manualSorting
                                    muiToolbarAlertBannerProps={
                                        isError
                                            ? {
                                                  color: 'error',
                                                  children: 'Error loading data',
                                              }
                                            : undefined
                                    }
                                    onColumnFiltersChange={setColumnFilters}
                                    onColumnFilterFnsChange={setColumnFiltersMode}
                                    onGlobalFilterChange={setGlobalFilter}
                                    onPaginationChange={setPagination}
                                    onSortingChange={setSorting}
                                    rowCount={rowCount}
                                    initialState={{
                                        showColumnFilters: true,
                                        density: 'compact',
                                        //columnPinning: { left: ["mrt-row-select"] },
                                    }}
                                    state={{
                                        columnFilterFns,
                                        columnFilters,
                                        globalFilter,
                                        isLoading,
                                        pagination,
                                        showAlertBanner: isError,
                                        showProgressBars: isRefetching,
                                        sorting,
                                    }}
                                    //positionToolbarDropZone={"top"}
                                    positionExpandColumn={'first'}
                                    positionActionsColumn={'first'}
                                    positionToolbarAlertBanner="bottom"
                                    localization={MRT_Localization_PT_BR}
                                />
                            </ThemeProvider>
                        </div>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                                Voltar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                disabled={novoColaborador.pessoaId ? true : false}
                            >
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
